import React from 'react';
import { TileLayer, LayersControl } from 'react-leaflet';

const { BaseLayer } = LayersControl;

// Map tile providers
export const MAP_LAYERS = {
  carto_dark: {
    name: 'Mapa Escuro',
    url: 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png',
    attribution: '&copy; <a href="https://carto.com/">CARTO</a>',
  },
  osm: {
    name: 'Mapa Padrão',
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
  },
  satellite: {
    name: 'Satélite',
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    attribution: '&copy; <a href="https://www.esri.com/">Esri</a>',
  },
  satellite_labels: {
    name: 'Satélite + Rótulos',
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    attribution: '&copy; <a href="https://www.esri.com/">Esri</a>',
    overlay: 'https://stamen-tiles.a.ssl.fastly.net/toner-labels/{z}/{x}/{y}.png',
  },
};

/**
 * MapLayerControl - Component to add layer switching to maps
 * 
 * Usage:
 * <MapContainer>
 *   <MapLayerControl defaultLayer="carto_dark" />
 *   ... other map components
 * </MapContainer>
 */
const MapLayerControl = ({ defaultLayer = 'carto_dark', position = 'topright' }) => {
  return (
    <LayersControl position={position}>
      <BaseLayer checked={defaultLayer === 'carto_dark'} name="Mapa Escuro">
        <TileLayer
          url={MAP_LAYERS.carto_dark.url}
          attribution={MAP_LAYERS.carto_dark.attribution}
        />
      </BaseLayer>
      
      <BaseLayer checked={defaultLayer === 'osm'} name="Mapa Padrão">
        <TileLayer
          url={MAP_LAYERS.osm.url}
          attribution={MAP_LAYERS.osm.attribution}
        />
      </BaseLayer>
      
      <BaseLayer checked={defaultLayer === 'satellite'} name="Satélite">
        <TileLayer
          url={MAP_LAYERS.satellite.url}
          attribution={MAP_LAYERS.satellite.attribution}
        />
      </BaseLayer>
    </LayersControl>
  );
};

export default MapLayerControl;
